// @ts-check
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { TextField } from '@material-ui/core';

export const StyledTextWrapper = styled.div`
  padding: 0.1rem 2.35rem 0.1rem 0;
  margin-top: 0.4rem;
  width: 80%;
`;

export const StyledTextFieldWrapper = styled.div`
  border: solid 1px ${getColor('botticelli')};
  border-radius: 2px;
  padding: 0.1rem 1rem;
  margin-top: 0.4rem;
  width: 80%;

  textarea::-webkit-input-placeholder {
    font-style: italic;
  }

  textarea:-moz-placeholder {
    font-style: italic;
  }

  textarea::-moz-placeholder {
    font-style: italic;
  }

  textarea:-ms-input-placeholder {
    font-style: italic;
  }
`;
export const StyledTextField = styled(TextField)`
  .MuiInputBase-root {
    color: ${getColor('shuttleGray')} !important;
  }

  .MuiInputBase-root.Mui-disabled {
    color: ${getColor('silver')} !important;
  }
`;

export const StyledInputWrappers = styled.div`
  width: 40%;
`;

export const StyledRadioRow = styled.div`
  display: flex;
  align-items: center;
  font-style: italic;
`;
